import React from 'react';
import { Link } from 'react-router-dom';
import './WhatWeDo.css';
import wwdImg1 from '../../assets/wwd/img1.png';
import wwdImg2 from '../../assets/wwd/img2.png';
import wwdImg3 from '../../assets/wwd/img3.png';
import wwdImg4 from '../../assets/wwd/img4.png';
import wwdImg5 from '../../assets/wwd/img5.png';
import wwdImg6 from '../../assets/wwd/img6.png';
import LatestProperties from '../../components/LatestProperties/LatestProperties';
import ConversationSection from '../../components/ConversationSection/ConversationSection';
import PropertyAdvantage from '../../components/PropertyAdvantage/PropertyAdvantage';

const WhatWeDo = () => {

    return (
        <>
            <section className="journey-section">
                <div className="journey-container">
                    {/* LEFT CONTENT */}
                    <div className="journey-left">
                        <span className="journey-tag">
                            Making Property Dreams Happen
                        </span>

                        <h2 className="journey-title">
                            From Search to Sanctuary<br /> We’re With You
                        </h2>

                        <p className="journey-text">
                            Built on a foundation of trust, transparency, and deep local expertise, we deliver seamless real estate solutions tailored to your unique needs. From your very first search to the
                            moment you find your perfect sanctuary, we ensure the journey is simple, secure, and truly rewarding.
                        </p>
                    </div>

                    {/* RIGHT CARD */}
                    <div className="journey-right">
                        <div className="journey-card">
                            <h3>Schedule a Call</h3>

                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                Integer nec odio. Praesent libero. Sed cursus ante dapibus.
                            </p>

                            <span className="journey-arrow">→</span>
                        </div>
                    </div>
                </div>
            </section>




            <section className="work-section">
                {/* SECTION TITLE */}
                <h2 className="work-title">The Way We Work</h2>

                {/* CARDS WRAPPER */}
                <div className="work-cards">
                    {/* CARD 1 */}
                    <div className="work-card">
                        <div className="work-icon">
                            <img src={wwdImg1} alt="" />
                        </div>
                        <h3>Buy & Sell Properties</h3>
                        <p>
                            Whether you’re seeking to buy or sell, our experts
                            are with you every step of the process, ensuring a
                            smooth procedure and helpful communication at every stage.
                        </p>
                        <Link to="/buy-sell-properties" className="work-btn">Read more <span>→</span></Link>
                    </div>

                    {/* CARD 2 */}
                    <div className="work-card">
                        <div className="work-icon">
                            <img src={wwdImg2} alt="" />
                        </div>
                        <h3>Property Management</h3>
                        <p>
                            Our expert team ensures seamless property management,
                            handling every detail from the ground up to deliver
                            exceptional results that exceed expectations.
                        </p>
                        <Link to="/property-management" className="work-btn">Read more <span>→</span></Link>
                    </div>

                    {/* CARD 3 */}
                    <div className="work-card">
                        <div className="work-icon">
                            <img src={wwdImg3} alt="" />
                        </div>
                        <h3>Real Estate Investment</h3>
                        <p>
                            Using our real estate expertise and leading market intelligence,
                            we provide our clients with solutions to their Real Estate Investments.
                        </p>
                        <Link to="/real-estate-investment" className="work-btn">Read more <span>→</span></Link>
                    </div>

                    {/* CARD 4 */}
                    <div className="work-card">
                        <div className="work-icon">
                            <img src={wwdImg4} alt="" />
                        </div>
                        <h3>Marketing & Management</h3>
                        <p>
                            We have a team of skilled professionals who take care
                            of execution of a property right from the scratch and give the best desired results.
                        </p>
                        <Link to="/marketing-management" className="work-btn">Read more <span>→</span></Link>
                    </div>

                    {/* CARD 5 */}
                    <div className="work-card">
                        <div className="work-icon">
                            <img src={wwdImg5} alt="" />
                        </div>
                        <h3>Rental Services</h3>
                        <p>
                            Our dedicated team of professionals ensures seamless rental solutions,
                            managing every detail with expertise to deliver the best results for
                            property owners and tenants alike.
                        </p>
                        <Link to="/rental-services" className="work-btn">Read more <span>→</span></Link>
                    </div>

                    {/* CARD 6 */}
                    <div className="work-card">
                        <div className="work-icon">
                            <img src={wwdImg6} alt="" />
                        </div>
                        <h3>Construction & Development</h3>
                        <p>
                            With a team of trained labors we construct your dream home
                            right from conception of the layout to complete construction.
                        </p>
                        <Link to="/construction-development" className="work-btn">Read more <span>→</span></Link>
                    </div>
                </div>
            </section>




            {/* LATEST PROPERTIES SECTION */}
            <LatestProperties />




            <PropertyAdvantage />
            <ConversationSection />




        </>
    );
};

export default WhatWeDo;
